import { Dispatch } from "common/types";

import { signInWithEmailAndPassword } from "features/user";

export function signInWithPassword({
  email,
  password,
  referralCode,
  onSignInSuccess,
  onSignInError
}: {
  email: string;
  password: string;
  referralCode?: string | null;
  onSignInSuccess?: () => void;
  onSignInError?: (error: Error) => void;
}) {
  return async function (dispatch: Dispatch) {
    try {
      await dispatch(signInWithEmailAndPassword(email, password, referralCode));
      onSignInSuccess?.();
    } catch (err: unknown) {
      const error = err as Error;
      onSignInError?.(error);
    }
  };
}
